import { SVGProps } from '../types';

const QiwiIcon = (props: SVGProps) => (
  <svg
    width="46"
    height="32"
    viewBox="0 0 46 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      fill="white"
    />
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      stroke="#DEDBD4"
    />
    <path
      d="M22.1064 6C27.17 6.00023 31.2596 10.2103 31.2598 15.4229C31.2598 17.1772 30.7732 18.8319 29.9941 20.2354C29.9455 20.2853 29.8965 20.2847 29.8965 20.1846C29.5556 17.8792 28.1926 16.6256 26.2451 16.2246C26.0505 16.1745 26.05 16.0753 26.293 16.0752C26.926 16.0251 27.7543 16.0248 28.2412 16.125C28.2899 15.8744 28.29 15.6233 28.29 15.4229C28.2899 12.0146 25.5628 9.20801 22.252 9.20801C18.9411 9.2081 16.215 12.0147 16.2148 15.4229C16.2148 18.8312 18.941 21.6386 22.252 21.6387H22.5439C22.4466 21.0874 22.3986 20.5359 22.4473 19.9346C22.4473 19.5336 22.5444 19.4834 22.6904 19.7842C23.5181 21.2877 24.7355 22.5902 27.0723 23.1416C28.9712 23.5927 30.8702 24.0945 32.9639 26.751C33.1586 27.0016 32.8666 27.2522 32.6719 27.0518C30.5783 25.1472 28.6795 24.4952 26.9268 24.4951C24.7359 24.5452 23.421 24.7958 22.1064 24.7959C17.0426 24.7959 12.9521 20.5855 12.9521 15.4229C12.9523 10.2603 17.0427 6 22.1064 6ZM26.7314 20.8369C26.9261 20.8369 27.1697 20.9364 27.4131 21.1367C27.8026 21.4875 27.9486 21.8887 27.7539 22.1895C27.6566 22.3398 27.4135 22.4404 27.2188 22.4404C26.9753 22.4404 26.732 22.3398 26.5859 22.1895C26.1965 21.8387 26.0986 21.3379 26.3418 21.0371C26.3905 20.9369 26.5368 20.837 26.7314 20.8369ZM28.29 19.3828C28.4359 19.2828 28.5817 19.2324 28.7275 19.2822C29.0683 19.4325 29.2147 19.9339 29.2148 20.1846C29.2635 20.5852 29.1663 20.7857 29.0205 20.7861C28.8744 20.7861 28.6791 20.636 28.4844 20.2852C28.2896 19.9343 28.1927 19.5833 28.29 19.3828Z"
      fill="#F28A1A"
    />
  </svg>
);

export { QiwiIcon };
